import { useBreakpointValue } from "@gluestack-style/react";
import { useGeneratePdf } from "@repo/core/hooks/useGeneratePdf";
import { useNavigation } from "@repo/core/hooks/useNavigation";
import { useRouteParams } from "@repo/core/hooks/useRouteParams";
import { ROUTES } from "@repo/core/routes";
import { AuthorizerTermType } from "@repo/core/services/entities/Authorizer";
import { CardConsultDataResponseDTO } from "@repo/core/services/entities/Card";
import { useStoresAndShopkeepersStore } from "@repo/core/stores/storesAndShopkeepers";

export const SimulateReceiptController = () => {
  const isMobile = useBreakpointValue({ base: true, md: false });
  const { viewRef, handleCaptureAndGeneratePDF, isLoading } = useGeneratePdf();
  const { selectedStore } = useStoresAndShopkeepersStore();
  const { replace } = useNavigation();
  const params = useRouteParams();

  const handleGoToSales = () => {
    replace(ROUTES.sales);
  };
  const handleGoToWithdraw = () => {
    replace(ROUTES.emergencyWithdraw);
  };
  return {
    isMobile,
    handleGoToSales,
    handleGoToWithdraw,
    selectedInstallmentOption: JSON.parse(
      params.selectedInstallmentOption
    ) as AuthorizerTermType,
    profileData: JSON.parse(params.profileData) as CardConsultDataResponseDTO,
    viewRef,
    handleCaptureAndGeneratePDF,
    isLoading,
    selectedStore
  };
};
